import { usePolicy } from '../../../../hooks';
import { enforce } from '../../../../util/abac';
import { useRecursiveCRDFetch } from '../ExecutiveSummary/useRecursiveCRDFetch';
import {
  hasDuplicateActiveStandardCarePlans,
  HEALTH_SUMMARY_AGENT,
} from './minimalActionPlan';

export const useCanGenerateWithAi = (carePlans?: fhir.CarePlan[]) => {
  const policy = usePolicy();
  const canInvokeAgent =
    enforce('invokeAgent', policy as any, {
      agent: HEALTH_SUMMARY_AGENT,
    }) || enforce('accessAdmin', policy as any);
  const { compositeReportDefinitions, isLoading: isLoadingCrds } =
    useRecursiveCRDFetch();
  const showGenerate =
    canInvokeAgent &&
    !isLoadingCrds &&
    compositeReportDefinitions.length > 0 &&
    !hasDuplicateActiveStandardCarePlans(carePlans);

  return { showGenerate, compositeReportDefinitions, isLoadingCrds };
};
